/* Mededelingenbalk: de berichtenwissel en het meetpunt.

   De balk werkt zonder JavaScript: het eerste bericht staat zichtbaar in de
   HTML en is gewoon een link. Wat hier staat is de wissel en het doorgeven
   van een klik aan de datalayer.

   Bewust geen wissel bij prefers-reduced-motion en niet bij een enkel
   bericht. Beweging die niets toevoegt is voor sommige mensen letterlijk
   misselijkmakend, en een balk die van een naar een wisselt is alleen maar
   onrust. */
(function () {
  'use strict';

  var balk = document.querySelector('[data-solza-balk]');
  if (!balk) return;

  var smal = window.matchMedia('(max-width: 749px)');
  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');

  function berichten() {
    /* Op een telefoon tellen de berichten die daar verborgen zijn niet mee.
       Zonder deze filter zou de wissel blijven hangen op een leeg beeld,
       want display:none maakt het bericht onzichtbaar maar niet
       overgeslagen. */
    return Array.prototype.filter.call(
      balk.querySelectorAll('[data-solza-balk-bericht]'),
      function (el) {
        return !(smal.matches && el.dataset.alleenDesktop === '1');
      }
    );
  }

  function toon(lijst, index) {
    lijst.forEach(function (el, i) {
      var aan = i === index;
      el.classList.toggle('solza-balk__bericht--aan', aan);
      if (aan) {
        el.removeAttribute('aria-hidden');
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('tabindex', '-1');
      }
    });
  }

  var timer = null;
  var huidig = 0;

  function stop() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  function start() {
    stop();
    var lijst = berichten();
    if (lijst.length < 2 || rustig.matches) {
      /* Eén bericht, of iemand die geen beweging wil: laat het eerste
         staan en doe verder niets. */
      huidig = 0;
      toon(lijst, 0);
      return;
    }
    if (huidig >= lijst.length) huidig = 0;
    toon(lijst, huidig);

    var seconden = parseInt(balk.dataset.wisseltijd, 10) || 5;
    timer = window.setInterval(function () {
      var nu = berichten();
      if (nu.length < 2) return;
      huidig = (huidig + 1) % nu.length;
      toon(nu, huidig);
    }, seconden * 1000);
  }

  /* Pauzeren op hover en op focus. Focus telt mee omdat iemand die met het
     toetsenbord op de link staat hem niet onder zijn vingers weg wil zien
     wisselen. */
  balk.addEventListener('mouseenter', stop);
  balk.addEventListener('mouseleave', start);
  balk.addEventListener('focusin', stop);
  balk.addEventListener('focusout', start);

  /* Bij het wisselen van schermbreedte of van de bewegingsvoorkeur opnieuw
     beginnen: welke berichten meedoen kan dan veranderd zijn. */
  var opnieuw = function () {
    huidig = 0;
    start();
  };
  if (smal.addEventListener) {
    smal.addEventListener('change', opnieuw);
    rustig.addEventListener('change', opnieuw);
  }

  balk.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-solza-balk-bericht]');
    if (!link) return;
    var tekst = link.querySelector('.solza-balk__tekst--breed');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'solza_mededelingenbalk_klik',
      mededeling: {
        /* Het nummer en de tekst van het bericht dat op dat moment stond,
           zodat te meten is welke invalshoek werkt. Geen persoonsgegevens. */
        bericht_nummer: parseInt(link.dataset.solzaBalkBericht, 10) || 0,
        bericht_tekst: tekst ? tekst.textContent.replace(/\s+/g, ' ').trim() : '',
        bestemming: link.getAttribute('href') || ''
      }
    });
  });

  start();
})();
